module.exports = __webpack_public_path__ + "image/copilot-xiao.bd9b7e31.png";